import React from "react";
import { Accordion, AccordionContent } from "../../../../components/accordion";
import { t } from "../../../../core/translate";
import { StyledAccordionButton, StyledCaret, ThemedList } from "./styles";
import { AccountIcon } from "./styles";
import {
  userInfo,
  devices,
  resources,
  notifications,
  languages,
  pod,
  completeAccount,
  optOut,
  cookieSettings
} from "../menu-items/account";

export default ({ headingLevel, openLanguages }) => {
  const data = [
    {
      listItems: [
        userInfo(),
        devices(),
        resources(),
        languages(openLanguages),
        pod(),
        completeAccount(),
        optOut(),
        cookieSettings()
      ].filter(el => !!el)
    }
  ];
  return (
    <Accordion>
      <StyledAccordionButton level={headingLevel}>
        <AccountIcon color="white" smallMargin viewBox="0 -6 36 36" />
        {t("base.account-plain", "Account")}
        <StyledCaret />
      </StyledAccordionButton>
      <AccordionContent>
        <ThemedList data={data} />
      </AccordionContent>
    </Accordion>
  );
};
